import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import {
  AllowTextMessagesContainerStyled,
  EditButtonWrapperStyled,
  ExtraInfoStyled,
  EmailInputContainerStyled,
  TextMessageToggleContainerStyled,
} from 'enrollment/features';
import { Spacer } from 'theSource/components';
import { formatPhoneForDisplay } from './utils';

export interface AllowTextMessagesProps {
  phoneNum: string | undefined;
  visible: boolean;
  checked: boolean | undefined;
}

export const AllowTextMessages = ({
  phoneNum,
  visible,
  checked,
}: AllowTextMessagesProps) => {
  const { t } = useTranslation('pages.communicationPreferencesLumos');
  const [allowText, setAllowText] = useState(Boolean(checked));
  const removeListenerController = new AbortController();

  const handleChange = () => {
    removeListenerController.abort(); // used to detach any previous event listeners
    setAllowText(!allowText);
  };

  useEffect(() => {
    // small timeout for new component to render
    setTimeout(() => {
      const toggle = document.getElementById('allow_text');
      if (!toggle) {
        return;
      }
      toggle.addEventListener(
        'change',
        () => {
          handleChange();
        },
        { signal: removeListenerController.signal }
      );
    }, 100);
  });

  if (!visible) {
    return null;
  }

  return (
    <AllowTextMessagesContainerStyled data-testid="allow-texts">
      <TextMessageToggleContainerStyled>
        <EditButtonWrapperStyled>
          <ps-toggle-switch
            input-id="allow_text"
            checked={allowText ? true : null}
            label={t('allowTextMessages')}
            extra-class="text-dark"
          />
        </EditButtonWrapperStyled>
        <ExtraInfoStyled className="body2">
          {t('allowTextMessagesInfo')}
        </ExtraInfoStyled>
        <Spacer height={1} />
      </TextMessageToggleContainerStyled>

      {allowText && (
        <EmailInputContainerStyled>
          <ps-text-field
            input-id="phone_number"
            label={t('cellLabel')}
            value={formatPhoneForDisplay(phoneNum)}
          ></ps-text-field>
        </EmailInputContainerStyled>
      )}
    </AllowTextMessagesContainerStyled>
  );
};
